(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["coco-art-delivery-quote"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const initialise = root => {
      if (root.dataset.initialised) return;
      root.dataset.initialised = 'true';
      const get = selector => root.querySelector(selector);
      const success = get('[data-success]');
      if (success) { success.focus({preventScroll:true}); return; }
      const open = get('[data-open]');
      if (!open) return;
      const form = root.querySelector('form');
      const details = get('[data-details]');
      const entry = get('[data-entry]');
      const review = get('[data-review-step]');
      const send = get('[data-send]');
      const reviewButton = get('[data-review]');
      const translations = Object.fromEntries([...root.querySelectorAll('[data-translations] [data-key]')].map(node => [node.dataset.key,node.textContent.trim()]));
      const say = key => { get('[data-announcement]').textContent = translations[key]; };
      const error = key => { const target=get('[data-error]');target.textContent=translations[key];target.hidden=false;target.scrollIntoView({block:'nearest'}); };
      const clearError = () => { get('[data-error]').hidden=true; };
      const field = key => get('[data-field="'+key+'"]');
      const locality = new URLSearchParams(window.location.search);
      const states = ['ACT','NSW','NT','QLD','SA','TAS','VIC','WA'];
      const preferredState = locality.get('art_state') || root.dataset.defaultState || '';
      const preferredPostcode = locality.get('art_postcode') || root.dataset.defaultPostcode || '';
      const preferredSuburb = locality.get('art_suburb') || root.dataset.defaultSuburb || '';
      if (!field('state').value && states.includes(preferredState)) field('state').value = preferredState;
      if (!field('postcode').value && /^[0-9]{4}$/.test(preferredPostcode)) field('postcode').value = preferredPostcode;
      if (!field('suburb').value && preferredSuburb.trim().length <= 100) field('suburb').value = preferredSuburb.trim();

      let snapshot = null;
      let busy = false;
      let nativeSubmit = false;
      const transition = operation => {
        if (document.startViewTransition && !window.matchMedia('(prefers-reduced-motion: reduce)').matches) document.startViewTransition(operation);
        else operation();
      };
      const focus = selector => { const heading=get(selector);heading.focus({preventScroll:true});heading.scrollIntoView({block:'nearest'}); };
      const money = (cents,currency) => new Intl.NumberFormat(document.documentElement.lang || 'en-AU',{style:'currency',currency}).format(Number(cents)/100);
      const publicProperties = supplied => {
        const entries = Array.isArray(supplied)
          ? supplied.filter(entry => Array.isArray(entry) && entry.length === 2)
          : supplied && typeof supplied === 'object' ? Object.entries(supplied) : [];
        return Object.fromEntries(entries.filter(([key, value]) => typeof key === 'string' && !key.startsWith('_') && ['string', 'number', 'boolean'].includes(typeof value)));
      };
      const fetchCart = async () => {
        const controller=new AbortController();const timeout=setTimeout(()=>controller.abort(),12000);
        try {
          const response=await fetch(root.dataset.cartUrl,{credentials:'same-origin',cache:'no-store',headers:{Accept:'text/html'},signal:controller.signal});
          if (!response.ok) throw new Error('cart_failed');
          const markup=new DOMParser().parseFromString(await response.text(),'text/html');
          const scoped=markup.querySelector('[data-art-quote-cart]');
          if(!scoped)throw new Error('cart_failed');
          const cart=JSON.parse(scoped.textContent);
          if (!Array.isArray(cart.items) || !cart.items.length) throw new Error('cart_empty');
          if (!/^[A-Z]{3}$/.test(cart.currency || '') || cart.items.some(item=>typeof item.quote_eligible!=='boolean')) throw new Error('cart_failed');
          if(cart.art_present!==true)throw new Error('no_eligible');
          const items=cart.items.filter(item=>item.quote_eligible).map(item=>{
            const properties=publicProperties(item.properties);
            return {product_id:item.product_id,variant_id:item.variant_id,title:String(item.product_title || item.title || ''),variant:String(item.variant_title || ''),sku:String(item.sku || ''),quantity:item.quantity,unit_price_minor:item.original_price,final_unit_price_minor:item.final_price,line_price_minor:item.original_line_price,final_line_price_minor:item.final_line_price,product_grams_each:item.grams,product_type:String(item.product_type || ''),quote_group:item.quote_group,properties};
          });
          if (items.some(item=>!Number.isInteger(item.quantity) || item.quantity<1 || !Number.isFinite(item.final_line_price_minor))) throw new Error('cart_failed');
          if (!items.length) throw new Error('no_eligible');
          const original=items.reduce((sum,item)=>sum+item.line_price_minor,0);
          const total=items.reduce((sum,item)=>sum+item.final_line_price_minor,0);
          const separate_items=cart.items.filter(item=>!item.quote_eligible).map(item=>({product_id:item.product_id,variant_id:item.variant_id,sku:String(item.sku || ''),title:String(item.product_title || ''),variant:String(item.variant_title || ''),quantity:item.quantity,unit_price_minor:item.original_price,final_unit_price_minor:item.final_price,final_line_price_minor:item.final_line_price,configured_product_grams_each:item.grams,product_type:String(item.product_type || ''),properties:publicProperties(item.properties),shipping_treatment:'Separate existing shipping; staff review required'}));
          return {currency:cart.currency,taxes_included:cart.taxes_included,original_total_minor:original,total_discount_minor:original-total,total_minor:total,configured_art_weight_grams:items.reduce((sum,item)=>sum+item.product_grams_each*item.quantity,0),weight_basis:'Configured artwork coefficient times billed whole-square-metre quantity; not proof of physical shipment mass, packed mass or cubic/chargeable weight',items,separate_items};
        } finally {clearTimeout(timeout);}
      };
      const renderBasket = cart => {
        const list=get('[data-basket-items]');list.replaceChildren();
        cart.items.forEach(item=>{const row=document.createElement('li');const product=document.createElement('span');const title=document.createElement('strong');title.textContent=item.title;product.append(title);const group=document.createElement('small');group.textContent=translations[item.quote_group==='piece'?'co_shipped_piece':'box_line'];product.append(group);if(item.variant && item.variant!=='Default Title'){const variant=document.createElement('small');variant.textContent=item.variant;product.append(variant);}Object.entries(item.properties).forEach(([key,value])=>{const property=document.createElement('small');property.textContent=key+': '+String(value);product.append(property);});const quantity=document.createElement('small');quantity.textContent=translations.quantity+' '+item.quantity;product.append(quantity);const price=document.createElement('span');price.textContent=money(item.final_line_price_minor,cart.currency);row.append(product,price);list.append(row);});
        get('[data-basket-total]').textContent=money(cart.total_minor,cart.currency)+' '+cart.currency;
        get('[data-basket-tax]').textContent=translations[cart.taxes_included?'tax_included':'tax_not_included'];
        const separate=get('[data-separate-items]');separate.replaceChildren();
        cart.separate_items.forEach(item=>{const row=document.createElement('li');const description=document.createElement('span');const title=document.createElement('strong');title.textContent=item.title;description.append(title);if(item.variant && item.variant!=='Default Title'){const variant=document.createElement('small');variant.textContent=item.variant;description.append(variant);}Object.entries(item.properties).forEach(([key,value])=>{const property=document.createElement('small');property.textContent=key+': '+String(value);description.append(property);});const quantity=document.createElement('small');quantity.textContent=translations.quantity+' '+item.quantity;description.append(quantity);row.append(description);separate.append(row);});
        get('[data-separate]').hidden=!cart.separate_items.length;
      };
      const writeSnapshot = cart => {get('[data-snapshot]').value=JSON.stringify({...cart,scope:'Custom Mosaic Art delivery quote; other basket items retain separate shipping rules; staff must confirm complete order',captured_at:new Date().toISOString()},null,2);};
      const addDetail = (list,key,value) => {const term=document.createElement('dt');term.textContent=translations[key];const detail=document.createElement('dd');detail.textContent=value;list.append(term,detail);};
      const renderReview = () => {
        const list=get('[data-review-summary]');list.replaceChildren();
        addDetail(list,'contact',[field('name').value,field('email').value,field('phone').value].join('\n'));
        addDetail(list,'address',[field('address').value,field('address2').value,[field('suburb').value,field('state').value,field('postcode').value].join(' '),translations.country].filter(Boolean).join('\n'));
        const selected=get('[data-field="location"]:checked');
        addDetail(list,'delivery',[selected?selected.parentElement.textContent.trim():'',field('forklift').selectedOptions[0].textContent].join('\n'));
        if(field('notes').value)addDetail(list,'notes',field('notes').value);
      };
      const valid = () => {
        root.querySelectorAll('input[data-field]:not([type="radio"]),textarea[data-field]').forEach(input=>{input.value=input.value.trim();});
        if (!form.checkValidity()) {error('invalid');entry.hidden=false;review.hidden=true;form.reportValidity();return false;}
        return true;
      };
      const setBusy = value => {busy=value;reviewButton.disabled=value;send.disabled=value;form.setAttribute('aria-busy',String(value));};
      open.disabled=false;reviewButton.disabled=false;
      open.addEventListener('click',()=>{transition(()=>{get('[data-start]').hidden=true;details.hidden=false;open.setAttribute('aria-expanded','true');focus('[data-entry-heading]');});});
      get('[data-edit]').addEventListener('click',()=>{if(busy)return;clearError();transition(()=>{entry.hidden=false;review.hidden=true;focus('[data-entry-heading]');});});
      reviewButton.addEventListener('click',async()=>{
        if(busy || !valid())return;
        clearError();setBusy(true);say('loading');
        try{snapshot=await fetchCart();renderBasket(snapshot);writeSnapshot(snapshot);renderReview();transition(()=>{entry.hidden=true;review.hidden=false;focus('[data-review-heading]');});}
        catch(exception){error(exception.message==='cart_empty'?'empty':exception.message==='no_eligible'?'no_eligible':'failed');}
        finally{setBusy(false);get('[data-announcement]').textContent='';}
      });
      form.addEventListener('submit',async event=>{
        if(nativeSubmit)return;
        event.preventDefault();
        if(busy)return;
        if(review.hidden || !snapshot){reviewButton.click();return;}
        if(!valid())return;
        clearError();setBusy(true);say('loading');
        try{
          const latest=await fetchCart();
          if(JSON.stringify(latest)!==JSON.stringify(snapshot)){snapshot=latest;renderBasket(snapshot);writeSnapshot(snapshot);renderReview();error('changed');return;}
          writeSnapshot(latest);nativeSubmit=true;setBusy(false);say('sending');form.requestSubmit(send);
        }catch(exception){nativeSubmit=false;error(exception.message==='cart_empty'?'empty':exception.message==='no_eligible'?'no_eligible':'failed');}
        finally{if(!nativeSubmit)setBusy(false);}
      });
    };
    document.querySelectorAll('[data-coco-art-quote]').forEach(initialise);
    document.addEventListener('shopify:section:load',event=>event.target.querySelectorAll('[data-coco-art-quote]').forEach(initialise));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["coco-freight-quote"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const initialise = root => {
      if (root.dataset.initialised) return;
      root.dataset.initialised = 'true';
      const get = selector => root.querySelector(selector);
      const success = get('[data-success]');
      if (success) { success.focus({preventScroll:true}); return; }
      const open = get('[data-open]');
      if (!open) return;
      const form = root.querySelector('form');
      const details = get('[data-details]');
      const entry = get('[data-entry]');
      const review = get('[data-review-step]');
      const send = get('[data-send]');
      const reviewButton = get('[data-review]');
      const translations = Object.fromEntries([...root.querySelectorAll('[data-translations] [data-key]')].map(node => [node.dataset.key,node.textContent.trim()]));
      const say = key => { get('[data-announcement]').textContent = translations[key]; };
      const error = key => { const target=get('[data-error]');target.textContent=translations[key];target.hidden=false;target.scrollIntoView({block:'nearest'}); };
      const clearError = () => { get('[data-error]').hidden=true; };
      const field = key => get('[data-field="'+key+'"]');
      let snapshot = null;
      let busy = false;
      let nativeSubmit = false;
      const transition = operation => {
        if (document.startViewTransition && !window.matchMedia('(prefers-reduced-motion: reduce)').matches) document.startViewTransition(operation);
        else operation();
      };
      const focus = selector => { const heading=get(selector);heading.focus({preventScroll:true});heading.scrollIntoView({block:'nearest'}); };
      const money = (cents,currency) => new Intl.NumberFormat(document.documentElement.lang || 'en-AU',{style:'currency',currency}).format(Number(cents)/100);
      const fetchCart = async () => {
        const controller=new AbortController();const timeout=setTimeout(()=>controller.abort(),12000);
        try {
          const response=await fetch(root.dataset.cartUrl,{credentials:'same-origin',cache:'no-store',headers:{Accept:'text/html'},signal:controller.signal});
          if (!response.ok) throw new Error('cart_failed');
          const markup=new DOMParser().parseFromString(await response.text(),'text/html');
          const scoped=markup.querySelector('[data-quote-cart]');
          if(!scoped)throw new Error('cart_failed');
          const cart=JSON.parse(scoped.textContent);
          if (!Array.isArray(cart.items) || !cart.items.length) throw new Error('cart_empty');
          if (!/^[A-Z]{3}$/.test(cart.currency || '') || cart.items.some(item=>typeof item.quote_eligible!=='boolean')) throw new Error('cart_failed');
          if(cart.box_present!==true)throw new Error('no_eligible');
          const items=cart.items.filter(item=>item.quote_eligible).map(item=>{
            const supplied=item.properties && typeof item.properties==='object' && !Array.isArray(item.properties)?item.properties:{};
            const properties=Object.fromEntries(Object.entries(supplied).filter(([key,value])=>!key.startsWith('_') && ['string','number','boolean'].includes(typeof value)));
            return {product_id:item.product_id,variant_id:item.variant_id,title:String(item.product_title || item.title || ''),variant:String(item.variant_title || ''),sku:String(item.sku || ''),quantity:item.quantity,unit_price_minor:item.original_price,final_unit_price_minor:item.final_price,line_price_minor:item.original_line_price,final_line_price_minor:item.final_line_price,product_grams_each:item.grams,product_type:String(item.product_type || ''),quote_group:item.quote_group,properties};
          });
          if (items.some(item=>!Number.isInteger(item.quantity) || item.quantity<1 || !Number.isFinite(item.final_line_price_minor))) throw new Error('cart_failed');
          if (!items.length) throw new Error('no_eligible');
          const original=items.reduce((sum,item)=>sum+item.line_price_minor,0);
          const total=items.reduce((sum,item)=>sum+item.final_line_price_minor,0);
          const separate_items=cart.items.filter(item=>!item.quote_eligible).map(item=>({product_id:item.product_id,variant_id:item.variant_id,sku:String(item.sku || ''),title:String(item.product_title || ''),quantity:item.quantity,final_line_price_minor:item.final_line_price,shipping_treatment:'Separate existing shipping; staff review required'}));
          return {currency:cart.currency,taxes_included:cart.taxes_included,original_total_minor:original,total_discount_minor:original-total,total_minor:total,product_weight_grams:items.reduce((sum,item)=>sum+item.product_grams_each*item.quantity,0),weight_basis:'Eligible tile product-only weight; excludes packaging and cubic/chargeable weight',items,separate_items};
        } finally {clearTimeout(timeout);}
      };
      const renderBasket = cart => {
        const list=get('[data-basket-items]');list.replaceChildren();
        cart.items.forEach(item=>{const row=document.createElement('li');const product=document.createElement('span');const title=document.createElement('strong');title.textContent=item.title;product.append(title);const group=document.createElement('small');group.textContent=translations[item.quote_group==='piece'?'co_shipped_piece':'box_line'];product.append(group);if(item.variant && item.variant!=='Default Title'){const variant=document.createElement('small');variant.textContent=item.variant;product.append(variant);}Object.entries(item.properties).forEach(([key,value])=>{const property=document.createElement('small');property.textContent=key+': '+String(value);product.append(property);});const quantity=document.createElement('small');quantity.textContent=translations.quantity+' '+item.quantity;product.append(quantity);const price=document.createElement('span');price.textContent=money(item.final_line_price_minor,cart.currency);row.append(product,price);list.append(row);});
        get('[data-basket-total]').textContent=money(cart.total_minor,cart.currency)+' '+cart.currency;
        get('[data-basket-tax]').textContent=translations[cart.taxes_included?'tax_included':'tax_not_included'];
        const separate=get('[data-separate-items]');separate.replaceChildren();
        cart.separate_items.forEach(item=>{const row=document.createElement('li');row.textContent=item.title+' — '+translations.quantity+' '+item.quantity;separate.append(row);});
        get('[data-separate]').hidden=!cart.separate_items.length;
      };
      const writeSnapshot = cart => {get('[data-snapshot]').value=JSON.stringify({...cart,scope:'Full boxes plus reviewed co-shipped pieces use one standard shipment; listed separate items retain separate shipping',captured_at:new Date().toISOString()},null,2);};
      const addDetail = (list,key,value) => {const term=document.createElement('dt');term.textContent=translations[key];const detail=document.createElement('dd');detail.textContent=value;list.append(term,detail);};
      const renderReview = () => {
        const list=get('[data-review-summary]');list.replaceChildren();
        addDetail(list,'contact',[field('name').value,field('email').value,field('phone').value].join('\n'));
        addDetail(list,'address',[field('address').value,field('address2').value,[field('suburb').value,field('state').value,field('postcode').value].join(' '),translations.country].filter(Boolean).join('\n'));
        const selected=get('[data-field="location"]:checked');
        addDetail(list,'delivery',[selected?selected.parentElement.textContent.trim():'',field('forklift').selectedOptions[0].textContent].join('\n'));
        if(field('notes').value)addDetail(list,'notes',field('notes').value);
      };
      const valid = () => {
        root.querySelectorAll('input[data-field]:not([type="radio"]),textarea[data-field]').forEach(input=>{input.value=input.value.trim();});
        if (!form.checkValidity()) {error('invalid');entry.hidden=false;review.hidden=true;form.reportValidity();return false;}
        return true;
      };
      const setBusy = value => {busy=value;reviewButton.disabled=value;send.disabled=value;form.setAttribute('aria-busy',String(value));};
      open.disabled=false;reviewButton.disabled=false;
      open.addEventListener('click',()=>{transition(()=>{get('[data-start]').hidden=true;details.hidden=false;open.setAttribute('aria-expanded','true');focus('[data-entry-heading]');});});
      get('[data-edit]').addEventListener('click',()=>{if(busy)return;clearError();transition(()=>{entry.hidden=false;review.hidden=true;focus('[data-entry-heading]');});});
      reviewButton.addEventListener('click',async()=>{
        if(busy || !valid())return;
        clearError();setBusy(true);say('loading');
        try{snapshot=await fetchCart();renderBasket(snapshot);writeSnapshot(snapshot);renderReview();transition(()=>{entry.hidden=true;review.hidden=false;focus('[data-review-heading]');});}
        catch(exception){error(exception.message==='cart_empty'?'empty':exception.message==='no_eligible'?'no_eligible':'failed');}
        finally{setBusy(false);get('[data-announcement]').textContent='';}
      });
      form.addEventListener('submit',async event=>{
        if(nativeSubmit)return;
        event.preventDefault();
        if(busy)return;
        if(review.hidden || !snapshot){reviewButton.click();return;}
        if(!valid())return;
        clearError();setBusy(true);say('loading');
        try{
          const latest=await fetchCart();
          if(JSON.stringify(latest)!==JSON.stringify(snapshot)){snapshot=latest;renderBasket(snapshot);writeSnapshot(snapshot);renderReview();error('changed');return;}
          writeSnapshot(latest);nativeSubmit=true;setBusy(false);say('sending');form.requestSubmit(send);
        }catch(exception){nativeSubmit=false;error(exception.message==='cart_empty'?'empty':exception.message==='no_eligible'?'no_eligible':'failed');}
        finally{if(!nativeSubmit)setBusy(false);}
      });
    };
    document.querySelectorAll('[data-coco-freight]').forEach(initialise);
    document.addEventListener('shopify:section:load',event=>event.target.querySelectorAll('[data-coco-freight]').forEach(initialise));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["coco-pool-mosaic-banner"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('coco-pool-mosaic-banner')) {
    customElements.define('coco-pool-mosaic-banner', class extends HTMLElement {
      connectedCallback() {
        this.motionButton = this.querySelector('.coco-pool-banner__motion');
        if (!this.motionButton || this.dataset.motionEnabled !== 'true') return;
        this.motionPreference = window.matchMedia('(prefers-reduced-motion: reduce)');
        this.manuallyPaused = false;
        this.updateMotion = () => {
          const paused = this.manuallyPaused || this.motionPreference.matches;
          this.dataset.motion = paused ? 'paused' : 'running';
          this.motionButton.hidden = this.motionPreference.matches;
          this.motionButton.querySelector('[data-pause-label]').hidden = paused;
          this.motionButton.querySelector('[data-play-label]').hidden = !paused;
        };
        this.toggleMotion = () => {
          this.manuallyPaused = !this.manuallyPaused;
          this.updateMotion();
        };
        this.motionButton.addEventListener('click', this.toggleMotion);
        this.motionPreference.addEventListener('change', this.updateMotion);
        this.updateMotion();
      }
      disconnectedCallback() {
        if (!this.motionButton || !this.motionPreference) return;
        this.motionButton.removeEventListener('click', this.toggleMotion);
        this.motionPreference.removeEventListener('change', this.updateMotion);
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header-BACKUP"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.getElementById('shopify-section-header');
      this.headerBounds = {};
      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-custom-product-mosaic"]) return;
  try {
    
  class ProductModal extends ModalDialog {
    constructor() {
      super();
    }

    hide() {
      super.hide();
    }

    show(opener) {
      super.show(opener);
      this.showActiveMedia();
    }

    showActiveMedia() {
      this.querySelectorAll(`[data-media-id]:not([data-media-id="${this.openedBy.getAttribute("data-media-id")}"])`).forEach((element) => {
          element.classList.remove('active');
        }
      )
      const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute("data-media-id")}"]`);
      const activeMediaTemplate = activeMedia.querySelector('template');
      const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
      activeMedia.classList.add('active');
      activeMedia.scrollIntoView();

      const container = this.querySelector('[role="document"]');
      container.scrollLeft = (activeMedia.width - container.clientWidth) / 2;

      if (activeMedia.nodeName == 'DEFERRED-MEDIA' && activeMediaContent && activeMediaContent.querySelector('.js-youtube'))
        activeMedia.loadContent();
    }
  }

  if (!customElements.get('product-modal')) customElements.define('product-modal', ProductModal);

  } catch(e) { console.error(e); }
})();
})();
